import { render } from "./itax_manage.vue?vue&type=template&id=19fe317d&scoped=true"
import script from "./itax_manage.vue?vue&type=script&lang=js"
export * from "./itax_manage.vue?vue&type=script&lang=js"

import "./itax_manage.vue?vue&type=style&index=0&id=19fe317d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fe317d"]])

export default __exports__